import React from "react";

export const required = value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="form-error">Required</div>;
  }
};

export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return <div className="form-error">The value exceeded {props.maxLength} length.</div>;
  }
};

export const numbersOnly = value => {
  if (!/^\d+$/.test(value)) {
    return <div className="form-error">Only Numbers are allowed.</div>;
  }
};



// WEBPACK FOOTER //
// ./src/utils/validators.js